import { EstateLevel } from "@1games-ru/region-shared/dist/enums/estate/estate";
import useIntercomShow from "@/domains/estate/hooks/useIntercomShow.ts";
import AccessWidget from "@/domains/estate/components/intercom/AccessWidget.tsx";
import {
  ApartmentStatus,
  IntercomWidgetVariant,
} from "@/domains/estate/components/intercom/const.ts";

function EstateIntercomContainer() {
  const { show, streetTransit, level, isLocked, updateLock } = useIntercomShow();

  if (!show || !level) {
    return null;
  }

  const intercomVariants = {
    [EstateLevel.Economy]: IntercomWidgetVariant.Simple,
    [EstateLevel.Standard]: IntercomWidgetVariant.Modern,
    [EstateLevel.Business]: IntercomWidgetVariant.Elite,
    [EstateLevel.Luxury]: IntercomWidgetVariant.Elite,
    [EstateLevel.Penthouse]: IntercomWidgetVariant.Elite,
  };

  return (
    <div className="absolute bottom-[--boundary-offset-y] left-[--boundary-offset-x]">
      <AccessWidget
        onEnter={() => streetTransit()}
        onLock={() => updateLock(true)}
        onUnlock={() => updateLock(false)}
        status={isLocked ? ApartmentStatus.Locked : ApartmentStatus.Unlocked}
        variant={intercomVariants[level]}
      />
    </div>
  );
}

export default EstateIntercomContainer;
